import React, { Suspense, lazy } from 'react'

const loadable = <P extends object>(importFunc: () => Promise<{ default: React.ComponentType<P> }>, fallback: React.ReactNode) => {
    const LazyComponent = lazy(importFunc)
    return (props: P) => (
        <Suspense fallback={fallback}>
            <LazyComponent {...props} />
        </Suspense>
    )
}

export default loadable
